import WINDOW from "./window";
import round from "./round";

const setWindowScroll = () => {
  const scroll = /** @type {WindowCoordinatesProps} */ (WINDOW.get("scroll"));

  scroll.set("x", round(window.scrollX));
  scroll.set("y", round(window.scrollY));

  // TODO:
  // const directionX = /** @type {EventDirectionProps} */ (scroll.get("direction"));
  // if (directionX.get("x") || directionX.get("y")) {
  //   scroll.set("initialized", true);
  // }
};

export default setWindowScroll;
